module.exports = __webpack_public_path__ + "img/no-view.ed800f2e.svg";